<template>
  <div class="viewurl-page">
    <el-row>
      <el-col :span="20">
        <el-breadcrumb style="margin-bottom:30px;" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item class="first-breadcrumb">{{ $t("SidebarMenu.Menu01") }}</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/Infringements/' + $route.params.Id }">{{ defalutbrand }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('Infringements.t0') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
      <el-col :span="4">
      </el-col>
    </el-row>    

    <div class="viewurl-page-table">
      <div class="tablebox">
        <el-table
          :data="tableData"
          :cell-style="this.getTableCellStyle"
          v-loading="tableloading" 
          tooltip-effect="dark" 
          style="width: 100%"
          @sort-change="sortthiscolumn"
        >
          <el-table-column prop='AssetID' label="ASSETID" width="110" show-overflow-tooltip></el-table-column>
          <el-table-column :label="$t('jgjk.s15')" show-overflow-tooltip>
            <template slot-scope="scope">
              <a :href="scope.row.URL" target="_blank">{{ scope.row.ProductName }}</a>
            </template>
          </el-table-column>
          <el-table-column :label="$t('activebrand.t50')" width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              <a :href="scope.row.ShopUrl" target="_blank">{{ scope.row.ShopName }}</a>
            </template>
          </el-table-column>
          <el-table-column :label="$t('Infringements.t9')" width="140">
            <template slot-scope="scope">
              <i v-if="scope.row.Daigou > 0" class="el-icon-success tableicontypes"></i>
            </template>
          </el-table-column>
          <el-table-column :label="$t('xfsp.sales')" prop='HighSales' width="80" sortable='custom'>
            <template slot-scope="scope">
              <i v-if="scope.row.HighSales > 0" class="el-icon-success tableicontypes"></i>
            </template>
          </el-table-column>
          <el-table-column :label="$t('Infringements.t10')" width="80">
            <template slot-scope="scope">
              <i v-if="scope.row.ImgCheck > 0" class="el-icon-success tableicontypes"></i>
            </template>
          </el-table-column>
          <el-table-column :label="$t('Infringements.t11')" prop='LowPrice' width="110" sortable='custom'>
            <template slot-scope="scope">
              <i v-if="scope.row.LowPrice > 0" class="el-icon-success tableicontypes"></i>
            </template>
          </el-table-column>
          <el-table-column :label="$t('xfsp.keywords')" width="80">
            <template slot-scope="scope">
              <i v-if="scope.row.KeyWords > 0" class="el-icon-success tableicontypes"></i>
            </template>
          </el-table-column>
          <el-table-column :label="$t('Infringements.t12')" prop='TotalScore' width="100" sortable='custom'>
            <template slot-scope="scope">
              {{scope.row.TotalScore}}
            </template>
          </el-table-column>
          <el-table-column :label="$t('Infringements.t14')" width="120" show-overflow-tooltip sortable='custom'>
            <template slot-scope="scope">
              {{scope.row.Qqfenlei}}
            </template>
          </el-table-column>
          <el-table-column :label="$t('Infringements.t13')" width="120" show-overflow-tooltip sortable='custom'>
            <template slot-scope="scope">
              {{scope.row.Suggestion}}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagewrap">
        <el-pagination
          small
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          popper-class="pagesizeclass"
          :page-sizes="[25, 50, 100]"
          :page-size="pagesize"
          layout="total, prev, pager, next, sizes"
          :total="pagingtotal">
        </el-pagination>      
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      subid: this.$route.params.Id,
      defalutbrand: '',
      tableData: [],
      tableloading: false,
      pagingtotal: 0,
      currentPage: 1,
      pagesize: 25,
      page: 1,
      tableorder: '01'
    }
  },

  mounted(){
    this.getEcommerceDefense()
    this.getPagelist()
  },

  methods: {

    /**
     * 获取品牌
     */
    getEcommerceDefense: function(){
      let that = this
      let commmerceArr = JSON.parse(localStorage.getItem("commmerce")).val
      for(let i=0; i<commmerceArr.length; i++){
        if(commmerceArr[i].subid/1 === that.$route.params.Id/1){
          that.defalutbrand = commmerceArr[i].name
        }
      }
    },

    /**
     * handleSizeChange
     */
    handleSizeChange: function(val){
      this.currentPage = 1
      this.page = 1
      this.pagesize = val
      this.getPagelist()
    },

    /**
     * handleCurrentChange
     */
    handleCurrentChange: function(val){
      this.page = val
      this.getPagelist()
    },

    /**
     * Paging
     */
    getPagelist: function(){
      let that = this
      let skuinfo = JSON.parse(localStorage.getItem("EcommerceDefenseTaskId")).val
      let url = that.API_URL + '/v3/commerce/merchandise/getFakeProduct'
      let data = {
        taskid: skuinfo.taskid,
        page: that.page,
        size: that.pagesize,
        order: that.tableorder
      }
      console.log(data)
      that.tableloading = true
      $.ajax({
        url:  url,
        type: "GET",
        data: data,
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          console.log('getPagelist', rex)
          let tablelists = rex.results[1]
          tablelists.forEach( item => {
            item.TotalScore = that.setLevels(item.TotalScore)
            item.Qqfenlei = that.setInfringementsType(item.Qqfenlei).txt
            item.Suggestion = that.setInfringementsSuggestion(item.Suggestion).txt
          })
          that.tableData = tablelists
          that.pagingtotal = rex.results[0][0].Count
          that.tableloading = false
        },
        error: function(response) {
          console.log('getPagelist', response)
        }
      })      
    },

    /**
     * 列表排序
     */
    sortthiscolumn: function(column){
      console.log(column)
      if(column.prop == "HighSales" && column.order == "ascending"){
        this.tableorder = '00'
        this.getPagelist()
      }else if(column.prop == "HighSales" && column.order == "descending"){
        this.tableorder = '01'
        this.getPagelist()
      }else if(column.prop == "HighSales" && column.order == null){
        this.tableorder = ''
        this.getPagelist()
      }else if(column.prop == "LowPrice" && column.order == "ascending"){
        this.tableorder = '10'
        this.getPagelist()
      }else if(column.prop == "LowPrice" && column.order == "descending"){
        this.tableorder = '11'
        this.getPagelist()
      }else if(column.prop == "LowPrice" && column.order == null){
        this.tableorder = ''
        this.getPagelist()
      }else if(column.prop == "TotalScore" && column.order == "ascending"){
        this.tableorder = '20'
        this.getPagelist()
      }else if(column.prop == "TotalScore" && column.order == "descending"){
        this.tableorder = '21'
        this.getPagelist()
      }else if(column.prop == "TotalScore" && column.order == null){
        this.tableorder = ''
        this.getPagelist()
      }else if(column.prop == 'Qqfenlei' && column.order == "ascending"){
        this.tableorder = '30'
        this.getPagelist()
      }else if(column.prop == 'Qqfenlei' && column.order == "descending"){
        this.tableorder = '31'
        this.getPagelist()
      }else if(column.prop == 'Qqfenlei' && column.order == null){
        this.tableorder = ''
        this.getPagelist()
      }else if(column.prop == 'Suggestion' && column.order == "ascending"){
        this.tableorder = '40'
        this.getPagelist()
      }else if(column.prop == 'Suggestion' && column.order == "descending"){
        this.tableorder = '41'
        this.getPagelist()
      }else if(column.prop == 'Suggestion' && column.order == null){
        this.tableorder = ''
        this.getPagelist()
      }else{
        return
      }
    },
    
    /**
     * 下载数据
     */
    downloaddata: function(){
      let that = this
      let skuinfo = JSON.parse(localStorage.getItem("EcommerceDefenseTaskId")).val
      let url = that.API_URL + '/v3/commerce/merchandise/getFakeProduct?'
                + 'taskid=' + skuinfo.taskid
                + '&order=' + that.tableorder
                + '&downfile=1'
      let setdate = new Date()
      let filename = setdate.getTime()
      let xhr = new XMLHttpRequest()
      xhr.open('GET', url, true)
      xhr.setRequestHeader("Authorization", 'Bearer '+JSON.parse(localStorage.getItem("token")).val+'')
      xhr.responseType = "blob"
      xhr.onload = function () {
        if (this.status === 200) {
          var blob = this.response;
          var reader = new FileReader()
          reader.readAsDataURL(blob)
          reader.onload = function (e) {
            var a = document.createElement('a')
            a.download = filename + '.xlsx'
            a.href = e.target.result
            $("body").append(a)
            a.click()
            $(a).remove()
          }
        }
      }
      xhr.send()      
    },
    
  },
}
</script>